import axios from 'axios';
import authHeader from "@/service/auth-header";

class TrackDataService {

    async getTrackDataForUser(userId) {
        return await axios.get(`/api/applications/si/trackdata/${userId}`, {headers: authHeader()})
    }

    async getTrackDataForUserAndCategory(userId, category) {
        return await axios.get(`/api/applications/si/trackdata/${userId}/category/${category}`, {headers: authHeader()})
    }

    async getTrackDataFeesForUser(userId) {
        return await axios.get(`/api/applications/si/trackdata/fees/${userId}`, {headers: authHeader()})
    }

    async getTrackData(id) {
        return await axios.get(`/api/applications/si/trackdata/specific/${id}`, {headers: authHeader()})
    }

    async createTrackData(userId, data) {
        // console.log("[TrackDataService][createTrackStock] userId = ", userId);
        // console.log("[TrackDataService][createTrackStock] data = ", data);
        return await axios.post(`/api/applications/si/trackdata/${userId}`, data, {headers: authHeader()});
    }

    async updateTrackData(id, data) {
        return await axios.put(`/api/applications/si/trackdata/${id}`, data, {headers: authHeader()});
    }

    async deleteTrackData(id) {
        return await axios.delete(`/api/applications/si/trackdata/${id}`, {headers: authHeader()})
    }

    async searchCodesForExchange(exchange, code) {
        return await axios.get(`/api/applications/si/trackdata/search/${exchange}/${code}`, {headers: authHeader()})
    }
}

export default new TrackDataService();
